<template>

  <!-- Modal -->
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Send Report</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="" data-vv-scope="formMonthlyReport">
          <div class="form-group" :class="{'error-input': errors.has('formMonthlyReport.wasProducedPerMonth')}">
            <label for="wasProducedPerMonth">Amounth of energy / month</label>
            <input type="text" name="wasProducedPerMonth" class="form-control" v-model="report.wasProducedPerMonth" v-validate="'required|numeric|min_value:0'" ref="wasProducedPerMonth" data-vv-as="Was produced per month (MWh)">            
            <span v-if="errors.has('formMonthlyReport.wasProducedPerMonth')" class="error">{{ errors.first('formMonthlyReport.wasProducedPerMonth') }}</span>
          </div>

          <div class="form-group">
            <select name="month" ref="selectMonth" data-vv-as="Month" v-validate="'required'" class="form-control">
              <option value="" disabled selected>Select Month</option>
              <option value="0">January</option>
              <option value="1">February</option>
              <option value="2">March</option>
              <option value="3">April</option>
              <option value="4">May</option>
              <option value="5">June</option>
              <option value="6">July</option>
              <option value="7">August</option>
              <option value="8">September</option>
              <option value="9">October</option>
              <option value="10">November</option>
              <option value="11">December</option>
            </select>
            <span v-if="errors.has('formMonthlyReport.month')" class="error">{{ errors.first('formMonthlyReport.month') }}</span>
          </div>

          <div class="input-field" :class="{'error-input': errors.has('formMonthlyReport.Year')}" style="padding-top:  13px;">
            <select name="Year" v-validate="'required'" ref="selectYear" data-vv-as="Year" class="form-control">
              <option value="" disabled selected>Select Year</option>
              <option value="2016">2016</option>
              <option value="2017">2017</option>
              <option value="2018">2018</option>
              <option value="2019">2019</option>
              <option value="2020">2020</option>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
            </select>
            <span v-if="errors.has('formMonthlyReport.Year')" class="error">{{ errors.first('formMonthlyReport.Year') }}</span>
          </div>

          <div class="input-field-indented"></div>

        </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" @click="sendReport()">Save changes</button>
        </div>
      </div>
    </div>
  </div>

  
</template>

<style type="text/css">
#exampleModalCenter.modal .modal-footer .btn-primary {
    padding: 8px 14px;
    background: #00b248;
    /*box-shadow: 0 3px 6px #d8d8d8;*/
    float: right;
    margin-left: 15px;
    transition: 0.3s;
    border: none;
    color: #fff;
}
#exampleModalCenter.modal .modal-title {
    width: auto;
    float: left;
}
#exampleModalCenter.modal .close {
    color: #00b248;
    opacity: 1;
    font-size: 50px;
    float: right;
    line-height: 20px;
}
#exampleModalCenter.modal .modal-body form .form-group {
    width: 48%;
    display: inline-block;
}
#exampleModalCenter.modal .modal-body form .form-group:first-child {width: 100%;}
#exampleModalCenter.modal .input-field {
    padding-top: 13px;
    width: 48%;
    display: inline-block;
    margin-left: 3%;
}
</style>
<script>
import { Toast, Api, Helper } from './../../../../../services'

export default {
  name: "ModalDialogExistingProjectSendReport",
  data() {
    return ({
      report: {
        project: "",
        wasProducedPerMonth: "",
      },
    })
  },
  methods: {
    openReport(project) {

      this.report.project = project
      this.report.wasProducedPerMonth = ""

       $('#exampleModalCenter').modal('show');
    },
    async sendReport() {
      try {

        const isValid = await this.$validator.validateAll("formMonthlyReport")
        if (!isValid) {
          Toast.error({
            toast: this.$toast,
            message: 'The entered data is not valid',
          })

          return
        }

        if (this.$parent.$refs.progress) {
          this.$parent.$refs.progress.show()
        } else {
          this.$parent.$parent.$refs.progress.show()
        }

        var newReport = {
          projectId: this.report.project._id,
          produced: this.report.wasProducedPerMonth,
          month: this.$refs.selectMonth.value,
          year: this.$refs.selectYear.value,
        }
        var response = await Api.sendMonthlyReportForExistingProjects(newReport)

        this.cancelReport()
      
        Toast.success({
          toast: this.$toast,
          message: "Monthly report successfully saved",
        })
      } catch (error) {
        console.error(error)

        Toast.error({
          toast: this.$toast,
          message: error.message,
        })
      } finally {
        if (this.$parent.$refs.progress) {
          this.$parent.$refs.progress.hide()
        } else {
          this.$parent.$parent.$refs.progress.hide()
        }
      }
    },
    cancelReport() {
      this.report.project = null
      // this.report.wasProducedPerMonth = ""
      this.report.monthly = ""

      $('#exampleModalCenter').modal('hide');
    },
  },
  mounted() {
    
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Account/MyProfile/Widget/ModalDialogs/ModalDialogExistingProjectSendReport.vue